import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { ClampedText } from "components/ui/clamped-text";
import { defaultLinkStyle } from "components/ui/link";
import React from "react";
import { breakNewlines } from "util/text";
import { ListableCommunity } from "../props";

interface LayoutItemPricingExistingProps {
    community: ListableCommunity;
    priceDisplay: string | undefined;
}

const PricingFile: React.FC<{
    file: ListableCommunity["pricing"]["files"][number];
}> = props => {
    const { file } = props;

    return (
        <a
            className={`${defaultLinkStyle} flex items-center gap-1 min-w-0`}
            href={file.downloadUrl}
            target="_blank"
            rel="noopener noreferrer">
            <ArrowDownTrayIcon className="w-4 h-4 flex-shrink-0" />
            <span>{file.name}</span>
        </a>
    );
};

export const LayoutItemPricingExisting: React.FC<
    LayoutItemPricingExistingProps
> = props => {
    const { community, priceDisplay } = props;
    const { pricing } = community;

    return (
        <dd className="mt-1 text-sm text-gray-900 space-y-2">
            {priceDisplay ? <div>{priceDisplay} / month</div> : null}
            {pricing?.notes && (
                <div className="text-gray-700 italic">
                    <ClampedText lines={3}>{breakNewlines(pricing.notes)}</ClampedText>
                </div>
            )}
            {pricing?.files?.length > 0 ? (
                <ul className="space-y-1">
                    {pricing.files.map((file, i) => (
                        <li key={i}>
                            <PricingFile file={file} />
                        </li>
                    ))}
                </ul>
            ) : null}
        </dd>
    );
};
